module.exports = __webpack_public_path__ + "static/media/laloba.89c1779a.jpg";